/* eslint-disable */
/**
 *
 * File API:
 * request(action)      meaning         show(store)
 * /        =>  root                =>   ''
 * A        =>  root/A              =>   'A'
 * A/B      =>  root/A/B            =>   'A/B'
 */

const root = "";
const requestRoot = "/";
const disPlayRoot = "root";

export const resolvePathFromStore = (path) => {
  if (path === root) {
    return requestRoot;
  }
  return path;
};

export const resolvePathFromDisplay = (path) => {
  if (path === disPlayRoot) {
    return root;
  }
  return path.split("root/")[1];
};

export const resolvePathFromStoreToMeaning = (path) => {
  if (path === root) {
    return disPlayRoot;
  }
  return `root/${path}`;
};
/**
 *
 * @param {string} path
 * @param {string} currentPath
 * append path on currentPath.
 * currentPath default is refering this.currentPath
 */
export function appendPath(path, currentPath = requestRoot) {
  const resolvedPath = resolvePathFromStore(currentPath);
  if (resolvedPath === requestRoot) return path;
  return `${resolvedPath}/${path}`;
}
export const removePath = (path, currentPath = requestRoot) =>
  // if currentPath not include '/', file is in root path
  !currentPath.includes("/") ? root : currentPath.replace(`/${path}`, "");

export const getCurrentPath = (path) => {
  if (!path) return;
  const routes = path.split("/");
  return path.includes("/") ? routes[routes.length - 1] : path;
};

/**
 * @description get working directory of full path
 */
export function getWorkingDirectory(path) {
  return path.split("/").slice(0, -1).join("/");
}

/**
 * @description get last folder or file of full path
 */
export function getTargetFolder(path) {
  return path.split("/").slice(-1).join("");
}
